import { OverlayModule } from '@angular/cdk/overlay';
import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseFormControlComponent } from '@shared/components/base-form-control/base-form-control';

import { IconComponent } from '../icon/icon.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, IconComponent, OverlayModule],
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SelectComponent),
    },
  ],
  selector: 'aux-select',
  styles: [
    `
      :host {
        position: relative;
      }
    `,
  ],
  templateUrl: './select.component.html',
})
export class SelectComponent extends BaseFormControlComponent<null | string> implements OnInit {
  private cdr = inject(ChangeDetectorRef);

  highlighted: null | number = null;
  isListOpen = false;
  optionCount = 0;
  @Input() options: string[] = [];
  selected = '';
  selectedIndex: null | number = null;

  ngOnInit(): void {
    this.optionCount = this.options.length;

    if (this.options.length) {
      // this.highlightOption(0);
      // this.selectOption();
    }
  }

  closeList() {
    this.isListOpen = false;
    this.highlighted = null;
    this.cdr.detectChanges();
  }

  highlightOption(index: number): void {
    this.highlighted = index;
  }

  onListKeydown(keydownEvent: KeyboardEvent): void {
    keydownEvent.preventDefault();
    // tslint:disable-next-line: deprecation
    switch (keydownEvent.key) {
      case 'ArrowDown':
        if (this.highlighted) {
          const index2 = this.highlighted + 1 > this.optionCount - 1 ? 0 : this.highlighted + 1;

          this.highlightOption(index2);
        }

        break;
      case 'ArrowUp':
        if (this.highlighted) {
          const index = this.highlighted - 1 < 0 ? this.optionCount - 1 : this.highlighted - 1;

          this.highlightOption(index);
        }

        break;
      case 'Enter':
      case 'Space':
        this.selectOption();
        break;
      case 'Escape':
        this.closeList();
        break;
      default:
        break;
    }
  }

  openList() {
    this.isListOpen = true;

    if (this.selectedIndex != null) {
      this.highlighted = this.selectedIndex;
    } else {
      this.highlighted = 0;
    }

    this.cdr.detectChanges();
  }

  selectOption(): void {
    const index = this.highlighted;

    if (index != null) {
      this.selected = this.options[index];
      this.selectedIndex = index;
      this.closeList();
    }
  }
}
